import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentUser: '',
    showLoader: false,
    config: {},
    userId: ''
}

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setCurrentUser: function (state, action) {
            state.currentUser = action.payload;
        },
        setShowLoader: function (state, action) {
            state.showLoader = action.payload;
        },
        setConfig: function (state, action) {
            state.config = action.payload;
        },
        setUserId: function (state, action) {
            state.userId = action.payload ?? '';
        }
    },
})

export const { setCurrentUser, setShowLoader, setConfig, setUserId } = sessionSlice.actions

export default sessionSlice.reducer
